import { getDateWithTime } from "@/lib/utils";
import { EventVisibility, UpdateEventDto } from "@classview/shared-types";

import { EventSchema } from "../types/manage-event.schema";

export function convertFormDataToApiData(
  organisationId: string,
  data: EventSchema,
) {
  const from = getDateWithTime(
    data.startDate,
    data.startTime ?? data.startDate,
  );
  const to = getDateWithTime(data.startDate, data.endTime ?? data.startDate);
  return {
    orgId: organisationId,
    event: {
      bannerS3Path: data.bannerS3Path,
      category: data.category,
      type: data.type,
      isCapacityCapped: data.isCapacityCapped,
      isFree: data.isFree,
      visibility: data.visibility as EventVisibility,
      isApprovalRequired: data.isApprovalRequired,
      ...(data.isCapacityCapped && {
        capacityLimit: data.capacityLimit,
      }),
      ...(!data.isFree && {
        cost: data.cost,
      }),
      session: {
        name: data.name,
        description: data.description,
        start: from.toISOString(),
        end: to.toISOString(),
        isScheduledToRecord: data.isScheduledToRecord,
        isClosedCaptionsEnabled: data.isClosedCaptionsEnabled,
        isParticipantScreenSharing: data.isParticipantScreenSharing,
        isRaisedHandSoundEnabled: data.isRaisedHandSoundEnabled,
        isChatEnabled: data.isChatEnabled,
      },
    },
  };
}

export function convertFormDataToUpdateApiData(
  data: EventSchema,
): UpdateEventDto {
  const from = data.startTime
    ? getDateWithTime(data.startDate, data.startTime)
    : undefined;
  const to = data.endTime
    ? getDateWithTime(data.startDate, data.endTime)
    : undefined;
  return {
    ...(data.bannerS3Path && { bannerS3Path: data.bannerS3Path }),
    ...(data.category && { category: data.category }),
    ...(data.type && { type: data.type }),
    // Include boolean values regardless of their truthiness
    isCapacityCapped: data.isCapacityCapped,
    isFree: data.isFree,
    visibility: data.visibility as EventVisibility,
    isApprovalRequired: data.isApprovalRequired,
    ...(data.isCapacityCapped === true && {
      capacityLimit: data.capacityLimit,
    }),
    ...(data.isFree === false && {
      cost: data.cost,
    }),
    session: {
      ...(data.name && { name: data.name }),
      ...(data.description && { description: data.description }),
      // Include boolean values regardless of their truthiness
      isScheduledToRecord: data.isScheduledToRecord,
      isClosedCaptionsEnabled: data.isClosedCaptionsEnabled,
      isParticipantScreenSharing: data.isParticipantScreenSharing,
      isRaisedHandSoundEnabled: data.isRaisedHandSoundEnabled,
      isChatEnabled: data.isChatEnabled,
      ...(data.startDate && {
        start: from?.toISOString(),
      }),
      ...(data.endTime && {
        end: to?.toISOString(),
      }),
    },
  };
}
